import { render, staticRenderFns } from "./IconSmartCash.vue?vue&type=template&id=47891ee5&"
import script from "./IconSmartCash.vue?vue&type=script&lang=ts&"
export * from "./IconSmartCash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports